"use client"

import Fade from 'react-reveal/Fade';
import { useState } from 'react';
import gif from "../../../public/gif1.gif"
import gif2 from "../../../public/gif2.gif"
import gif3 from "../../../public/gif3.gif"
import gif4 from "../../../public/gif4.gif"
import gif5 from "../../../public/gif5.gif"
import gif6 from "../../../public/git7.gif"
import Image from 'next/image';
import heelio from "../../../public/heelio-mini.svg"
import { useRouter } from "next/navigation";

function Reporting(){

    const [menu, setMenu] = useState(0)
    const router = useRouter();


    return(
        <div className='mt-20 pt-20 max-w-[1400px] mx-auto bg-[#CCDDEE] lg:rounded-3xl'>
                    <div className="overflow-hidden pb-2">
                        <Fade bottom>
                            <h4 className="text-2xl font-bold tracking-tight text-center text-gray-900 sm:text-5xl">
                            Automatisez votre reporting et vos analyses
                            </h4>
                        </Fade>
                    </div>

                    <div className="overflow-hidden">
                        <Fade bottom>
                            <p className="mt-4 text-xl leading-8 text-gray-600 text-center">
                                Suivi financier en temps réel
                            </p>
                        </Fade>
                    </div>

                
                    <div className="flex flex-col justify-center items-center md:gap-10 text-[#042040] my-5 mx-2 mt-10 md:mx-20">
                        <div className='relative mx-auto'>
                            <div className="flex justify-center items-center flex-wrap sm:flex-nowrap gap-5 xl:gap-10 select-none">
                            <p 
                                className={`px-3 sm:px-7 text-xs sm:text-md md:text-lg font-bold text-[#042040] py-3 rounded-full cursor-pointer border border-4 ${menu == 0? "shadow-[5px_5px_0px_#FED90F] hover:shadow-none ease-in duration-500 border border-4 hover:border-[#FED90F] border-[#042040] bg-[#fafafa]" : "border-[#CCDDEE] border border-4 hover:border-[#042040] ease-in duration-500 hover:bg-white"}`}
                                onClick={() => setMenu(0)}
                            >Connecter</p>

                            <div className="h-10 w-px bg-slate-500/20"></div>

                            <p
                                className={`px-3 sm:px-7 text-xs sm:text-md md:text-lg font-bold text-[#042040] py-3 rounded-full cursor-pointer border border-4 ${menu == 1? "shadow-[5px_5px_0px_#FED90F] hover:shadow-none ease-in duration-500 border border-4 hover:border-[#FED90F] border-[#042040] bg-[#fafafa]" : "border-[#CCDDEE] border border-4 hover:border-[#042040] ease-in duration-500 hover:bg-white"}`}
                                onClick={() => setMenu(1)}
                            >Maîtriser</p>

                            <div className="h-10 w-px bg-slate-500/20"></div>

                            <p
                                className={`px-3 sm:px-7 text-xs sm:text-md md:text-lg font-bold text-[#042040] py-3 rounded-full cursor-pointer border border-4 ${menu == 2? "shadow-[5px_5px_0px_#FED90F] hover:shadow-none ease-in duration-500 border border-4 hover:border-[#FED90F] border-[#042040] bg-[#fafafa]" : "border-[#CCDDEE] border border-4 hover:border-[#042040] ease-in duration-500 hover:bg-white"}`}
                                onClick={() => setMenu(2)}
                            >Collaborer</p>
                            
                            
                            </div>
                        </div>

                        {menu == 0 ?
                            <div className='flex justify-center items-center gap-20 flex-wrap lg:flex-nowrap mb-28 mt-10 mx-5 text-[#042040]'>
                                <Fade>
                                    <div className='flex justify-start items-start gap-5 flex-nowrap w-full lg:w-1/2'>
                                        <svg className='hidden md:block' width="100" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 12H20M20 12L16 8M20 12L16 16" stroke="#042040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        <div className="overflow-hidden ">

                                                <p className="text-md leading-8  text-left font-semibold">
                                                    🌐 Obtenez un tableau de bord financier en temps réel, sur mesure pour votre secteur.
                                                </p>
                                            
                                                <p className="mt-4 text-md leading-8  text-left">
                                                    Une vision financière complète et instantanée en connectant vos comptes bancaires, votre logiciel comptable et vos logiciels d’encaissement comme Stripe ou Paypal.
                                                </p>

                                                <p className="mt-4 text-md leading-8  text-left font-semibold">
                                                    🚀 Eliminez les erreurs manuelles
                                                </p>

                                                <p className="mt-4 text-md leading-8  text-left">
                                                Bénéficiez d&apos;une catégorisation automatique et d&apos;une organisation ergonomique de vos flux financiers.
                                                </p>
                                                
                                                <p 
                                                    onClick={() => router.push("/reporting")}
                                                    className='mt-5 underline cursor-pointer flex gap-2 text-sm'
                                                ><Image src={heelio} alt="heelio logo" width={20}/><span>En savoir plus</span></p>
                                        </div>
                                    </div>
                                </Fade>
                                <Fade bottom>
                                    <div className='relative lg:w-5/6'>              
                                        <Image src="https://media.giphy.com/media/CnsAYVL4VxC7TvA76S/giphy.gif" width={100} height={100} alt="heelio software" className='w-full lg:w-3/4 border border-4 border-[#042040] rounded-3xl shadow-[5px_5px_0px_#FED90F]'/>  
                        
                                        <Image src="https://media.giphy.com/media/9OG5wXaGjptXuXZrrI/giphy.gif" width={100} height={100} alt="heelio software" className='hidden md:block absolute top-20 md:top-20 lg:top-20 left-40 md:left-40 lg:left-48 w-5/6 lg:w-3/4 border border-4 border-[#042040] rounded-3xl shadow-[5px_5px_0px_#FED90F]'/>             
                                    </div>
                                </Fade>
                            </div>
                        :
                            menu == 1 ?

                                <div className='flex justify-center items-center gap-20 flex-wrap lg:flex-nowrap mb-28 mt-10 mx-5 text-[#042040]'>
                                    <Fade>
                                        <div className='flex justify-start items-start gap-5 flex-nowrap w-full lg:w-1/2'>
                                            <svg className='hidden md:block' width="100" height="65" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 12H20M20 12L16 8M20 12L16 16" stroke="#042040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            <div className="overflow-hidden">
                                                <Fade bottom delay={220}>
                                                    <p className="mt-4 text-md leading-8  text-left font-semibold">
                                                    💡 Gagnez du temps grâce aux mises à jour automatiques des données réelles
                                                    </p>
                                                </Fade>
                                                <Fade bottom>
                                                    <p className="mt-4 text-md leading-8  text-left">
                                                        Importez, ajustez et comparez automatiquement vos données réelles et prévisionnelles directement sur notre plateforme.
                                                    </p>
                                                </Fade>
                                                <Fade bottom delay={230}>
                                                    <p className="text-md leading-8  text-left font-semibold mt-4">
                                                    🔒 Manipulez et exploitez vos données en toute confiance
                                                    </p>
                                                </Fade>
                                                <Fade bottom delay={200}>
                                                    <p className="mt-4 text-md leading-8  text-left">
                                                        Précision et intégrité de vos données garantie par la supervision d&apos;un directeur financier heelio.
                                                    </p>
                                                </Fade>

                                                <Fade bottom>
                                                    <p 
                                                        onClick={() => router.push("/reporting")}
                                                        className='mt-5 underline cursor-pointer flex gap-2 text-sm'
                                                    ><Image src={heelio} alt="heelio logo" width={20}/><span>En savoir plus</span></p>
                                                </Fade>

                                                
                                                

                                            </div>
                                        </div>
                                    </Fade>
                                    <Fade bottom>
                                        <div className='relative lg:w-5/6'>              
                                            <Image src="https://media.giphy.com/media/ix5BIIlDtjqI58YAIU/giphy.gif" width={100} height={100} alt="heelio software" className='w-full lg:w-3/4 border border-4 border-[#042040] rounded-3xl shadow-[5px_5px_0px_#FED90F]'/>  
                            
                                            <Image src="https://media.giphy.com/media/kWWM1KKB1ZhtBHIBHo/giphy.gif" width={100} height={100} alt="heelio software" className='hidden md:block absolute top-20 md:top-20 lg:top-20 left-40 md:left-40 lg:left-48 w-5/6 lg:w-3/4 border border-4 border-[#042040] rounded-3xl shadow-[5px_5px_0px_#FED90F]'/>             
                                        </div>
                                    </Fade>
                                </div>
                            :
                            
                                <div className='flex justify-center items-center gap-20 flex-wrap lg:flex-nowrap mb-28 mt-10 mx-5 text-[#042040]'>
                                    <Fade>
                                        <div className='flex justify-start items-start gap-5 flex-nowrap w-full lg:w-1/2'>
                                            <svg className='hidden md:block' width="100" height="65" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 12H20M20 12L16 8M20 12L16 16" stroke="#042040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            <div className="overflow-hidden">

                                                <Fade bottom delay={200}>
                                                    <p className="mt-4 text-md leading-8  text-left font-semibold">
                                                    🤝 Une collaboration efficace et sans faille avec votre directeur financier heelio.
                                                    </p>
                                                </Fade>
                                                <Fade bottom>
                                                    <p className="mt-4 text-md leading-8  text-left">
                                                    Suivez et annotez chaque modification pour une traçabilité parfaite de vos données. 
                                                    </p>
                                                </Fade>

                                                
                                                <Fade bottom delay={220}>
                                                    <p className="mt-4 text-md leading-8  text-left font-semibold">
                                                    📤 Un partage et une personnalisation de vos analyses faciles et sans limite. 
                                                    </p>
                                                </Fade>

                                                <Fade bottom delay={210}>
                                                    <p className="mt-4 text-md leading-8  text-left">
                                                        Exportez vos données sur Excel.
                                                    </p>
                                                </Fade>
                                                
                                                

                                                <Fade bottom>
                                                    <p 
                                                        onClick={() => router.push("/reporting")}
                                                        className='mt-5 underline cursor-pointer flex gap-2 text-sm'
                                                    ><Image src={heelio} alt="heelio logo" width={20}/><span>En savoir plus</span></p>
                                                </Fade>
                                                
                                                
                                                <p></p>
                                            </div>
                                        </div>
                                    </Fade>
                                    <Fade bottom>
                                        <div className='relative lg:w-5/6'>              
                                            <Image src="https://media.giphy.com/media/elSnJoSfDQdBXRXeLp/giphy.gif" width={100} height={100} alt="heelio software" className='w-full lg:w-3/4 border border-4 border-[#042040] rounded-3xl shadow-[5px_5px_0px_#FED90F]'/>  
                            
                                            <Image src="https://media.giphy.com/media/JOpB1LWfnedOuwrknY/giphy.gif" width={100} height={100} alt="heelio software" className='hidden md:block absolute top-20 md:top-20 lg:top-20 left-40 md:left-40 lg:left-48 w-5/6 lg:w-3/4 border border-4 border-[#042040] rounded-3xl shadow-[5px_5px_0px_#FED90F]'/>             
                                        </div>
                                    </Fade>
                        </div>
                    }

                    </div>
              
        </div>
    )
}

export default Reporting;